// extracted by mini-css-extract-plugin
export default {"services":"Services_services__xX7EU","services_content":"Services_services_content__srsrg","heading":"Services_heading__ugVvv","body":"Services_body__wEoQV"};